import React from 'react';
import Collapsible from 'react-collapsible';
import QuestionHead from './QuestionHead';
import QuestionDetails from './QuestionDetails';
import {inject, observer} from 'mobx-react';

@inject('workshopDetails')
@observer
export default class QuestionDetailsContainer extends React.Component {




  render(){
    let question = this.props.workshopDetails.workshop.modules[this.props.moduleId].questions[this.props.questionId];
    const accordionHeader = <QuestionHead text={question.text}  number={this.props.questionId} status={question.status}/>;
    return(
      <Collapsible
        className="accordion-item"
        openedClassName="accordion-item is-active"
        trigger={accordionHeader}
        >
        <QuestionDetails moduleId={this.props.moduleId}
                         questionId={this.props.questionId}/>
      </Collapsible>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/question/QuestionDetailsContainer.jsx